export default __webpack_public_path__ + "static/media/stress.60e3f496.svg";